import styled from "styled-components";

export const MainCard = styled.div`
  height: 100%;
  position: relative;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;